export interface RemoveWaitlistFormDto {
  removalReason: string;
}

export const createRemoveWaitlistFormDto = (): RemoveWaitlistFormDto => {
  return {
    removalReason: "",
  };
};
